import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stats } from '@/mocks/site';

const quickTags = [
  { label: '已辟谣', to: '/topics?status=debunked' },
  { label: '求证中', to: '/topics?status=pending' },
  { label: '科技爆料', to: '/topics?category=tech' },
  { label: '社会热点', to: '/topics?category=society' },
];

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : '/topics');
  };

  return (
    <section className="relative w-full overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0 grain-paper opacity-60" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-12 md:px-6 md:pb-20 md:pt-16 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs font-medium text-primary-700 animate-fade-up">
            <i className="ri-flashlight-line"></i>
            网络爆料 · 求证专区
          </span>

          <h2 className="mt-5 font-heading text-3xl font-black leading-[1.15] text-foreground-950 text-balance animate-fade-up delay-100 md:text-5xl">
            先别急着转发，
            <br />
            我们先替你把事情
            <span className="relative mx-1 inline-block">
              <span className="relative z-10 text-primary-600">弄明白</span>
              <span className="absolute bottom-1 left-0 z-0 h-3 w-full bg-primary-200/70" aria-hidden="true"></span>
            </span>
          </h2>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 animate-fade-up delay-200 md:text-base">
            围绕网络爆料真假、求证、辟谣与扒皮，我们把零散的网传说法整理成结构化档案：传闻原文、来源出处、时间线、佐证与反证，
            以及一个尽可能诚实的结论。理性吃瓜，从看清证据开始。
          </p>

          <form onSubmit={handleSearch} className="mt-7 flex w-full max-w-lg flex-col gap-2 sm:flex-row animate-fade-up delay-300">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜话题、关键词或传闻原文…"
                aria-label="搜索求证话题"
                className="w-full rounded-full border border-background-300 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-eye-line"></i>
              开始求证
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2 animate-fade-up delay-400">
            <span className="font-label text-xs text-foreground-500">热门：</span>
            {quickTags.map((tag) => (
              <button
                key={tag.label}
                type="button"
                onClick={() => navigate(tag.to)}
                className="cursor-pointer rounded-full border border-background-300 bg-background-100 px-3 py-1 font-label text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {tag.label}
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative animate-fade-in delay-200">
            <div className="h-64 w-full overflow-hidden rounded-2xl border border-background-200 sm:h-72 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20a%20magnifying%20glass%20over%20scattered%20paper%20documents%20on%20warm%20cream%20desk%2C%20muted%20amber%20and%20deep%20jade%20green%20geometric%20accents%2C%20minimal%20flat%20vector%20style%2C%20soft%20paper%20grain%2C%20calm%20composition%2C%20no%20text&width=900&height=700&seq=gt-hero-main&orientation=landscape"
                alt="以暖色几何插画表现的求证与核对场景"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-5 -left-3 w-56 rounded-xl border border-background-200 bg-background-50 p-4 sm:left-4">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-shield-check-line"></i>
                </span>
                <span className="font-label text-xs text-foreground-600">今日更新结论</span>
              </div>
              <p className="mt-2 font-heading text-lg font-bold text-foreground-950">3 条</p>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">含 1 条辟谣、2 条求证进展</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-background-200 bg-background-100/70">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-2 gap-6 px-4 py-7 md:grid-cols-4 md:px-6">
          {stats.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{item.value}</span>
                <span className="font-label text-xs text-foreground-600">{item.label}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}